// extracted by mini-css-extract-plugin
module.exports = {"bar":"style_bar__3yVAf","percentageAndBar":"style_percentageAndBar__6WV0A"};